module.exports = __webpack_public_path__ + "img/pin-icon.e186b890.svg";